export const FETCH_RAPPELS = 'FETCH_RAPPELS';
export const FETCH_RAPPEL = 'FETCH_RAPPEL';
export const ADD_RAPPEL = 'ADD_RAPPEL';
export const UPDATE_RAPPEL = 'UPDATE_RAPPEL';
export const DELETE_RAPPEL = 'DELETE_RAPPEL';

/* use the state type FETCH_RAPPELS FETCH_RAPPEL ADD_RAPPEL  UPDATE_RAPPEL DELETE_RAPPEL*/
